import type { ChartOption } from '../_config/_interface';

/**
 * 百分比折线图 Y 轴：min=0、标签带 %、不固定 max=100（与 PercentStackBar 不同）。
 */
export function configurePercentLineYAxis(option: ChartOption): ChartOption {
  const nextOption = { ...option };

  if (nextOption.yAxis && Array.isArray(nextOption.yAxis) && nextOption.yAxis[0]) {
    nextOption.yAxis[0] = {
      ...nextOption.yAxis[0],
      min: 0,
    };
    delete (nextOption.yAxis[0] as { max?: number; }).max;

    const axisLabel = nextOption.yAxis[0].axisLabel ?? {};
    nextOption.yAxis[0].axisLabel = {
      ...axisLabel,
      formatter: (value: number) => `${value}%`,
    };
  }

  if (nextOption.tooltip) {
    nextOption.tooltip = {
      ...nextOption.tooltip,
      axisPointer: {
        ...(nextOption.tooltip.axisPointer ?? {}),
        type: 'line',
      },
    };
  }

  return nextOption;
}
